class ProductReviews {
  constructor() {
    this.productId = document.querySelector('.product-reviews').dataset.productId;
    this.reviews = [];
    this.currentPage = 1;
    this.reviewsPerPage = 5;
    this.storageKey = `product_reviews_${this.productId}`;
    
    this.init();
  }

  init() {
    this.loadReviews();
    this.attachEventListeners();
    this.displayReviews();
  }

  // Load reviews from localStorage
  loadReviews() {
    const storedReviews = localStorage.getItem(this.storageKey);
    this.reviews = storedReviews ? JSON.parse(storedReviews) : [];
  }

  // Save reviews to localStorage
  saveReviews() {
    localStorage.setItem(this.storageKey, JSON.stringify(this.reviews));
  }

  // Attach event listeners
  attachEventListeners() {
    // Write review button
    document.getElementById('write-review-btn').addEventListener('click', () => {
      this.toggleReviewForm();
    });

    // Cancel button
    document.getElementById('cancel-review-btn').addEventListener('click', () => {
      this.toggleReviewForm(false);
      this.resetForm();
    });

    // Star rating input
    const starInputs = document.querySelectorAll('.star-input');
    starInputs.forEach(star => {
      star.addEventListener('click', (e) => {
        const value = parseInt(e.target.dataset.value);
        this.setRating(value);
      });
      
      star.addEventListener('mouseover', (e) => {
        const value = parseInt(e.target.dataset.value);
        this.highlightStars(value);
      });
    });

    document.getElementById('star-rating-input').addEventListener('mouseleave', () => {
      const currentRating = parseInt(document.getElementById('rating-input').value);
      this.highlightStars(currentRating || 0);
    });

    // Submit review
    document.getElementById('review-form').addEventListener('submit', (e) => {
      e.preventDefault();
      this.submitReview();
    });

    // Load more button
    document.getElementById('load-more-btn').addEventListener('click', () => {
      this.currentPage++;
      this.displayReviews();
    });
  }

  // Toggle review form visibility
  toggleReviewForm(show = null) {
    const form = document.getElementById('review-form-wrapper');
    const btn = document.getElementById('write-review-btn');
    
    if (show === null) {
      show = form.style.display === 'none';
    }
    
    form.style.display = show ? 'block' : 'none';
    btn.style.display = show ? 'none' : 'inline-block';
    
    if (show) {
      form.scrollIntoView({ behavior: 'smooth' });
    }
  }

  // Set rating
  setRating(value) {
    document.getElementById('rating-input').value = value;
    this.highlightStars(value);
  }

  // Highlight stars
  highlightStars(count) {
    const stars = document.querySelectorAll('.star-input');
    stars.forEach(star => {
      const starValue = parseInt(star.dataset.value);
      if (starValue <= count) {
        star.classList.add('active');
      } else {
        star.classList.remove('active');
      }
    });
  }

  // Submit review
  submitReview() {
    const formData = {
      id: Date.now(),
      name: document.getElementById('reviewer-name').value.trim(),
      email: document.getElementById('reviewer-email').value.trim(),
      rating: parseInt(document.getElementById('rating-input').value),
      title: document.getElementById('review-title').value.trim(),
      body: document.getElementById('review-body').value.trim(),
      date: new Date().toISOString(),
      verified: true
    };

    // Validate form
    if (!formData.name || !formData.email || !formData.rating || !formData.body) {
      this.showMessage('Please fill in all required fields.', 'error');
      return;
    }

    if (formData.rating === 0) {
      this.showMessage('Please select a rating.', 'error');
      return;
    }

    // Add review
    this.reviews.unshift(formData);
    this.saveReviews();
    
    // Reset and close form
    this.resetForm();
    this.toggleReviewForm(false);
    
    // Update display
    this.currentPage = 1;
    this.displayReviews();
    this.showMessage('Thank you for your review! It has been submitted.', 'success');
    
    // Scroll to reviews list
    setTimeout(() => {
      document.getElementById('reviews-list').scrollIntoView({ behavior: 'smooth' });
    }, 500);
  }

  // Reset form
  resetForm() {
    document.getElementById('review-form').reset();
    document.getElementById('rating-input').value = 0;
    this.highlightStars(0);
    document.getElementById('form-message').className = 'form-message';
    document.getElementById('form-message').style.display = 'none';
  }

  // Show message
  showMessage(message, type) {
    const messageEl = document.getElementById('form-message');
    messageEl.textContent = message;
    messageEl.className = `form-message ${type}`;
    messageEl.style.display = 'block';
    
    if (type === 'success') {
      setTimeout(() => {
        messageEl.style.display = 'none';
      }, 5000);
    }
  }

  // Display reviews
  displayReviews() {
    const reviewsList = document.getElementById('reviews-list');
    const loadMoreWrapper = document.getElementById('load-more-wrapper');
    const noReviews = document.getElementById('no-reviews');
    
    // Clear existing reviews
    reviewsList.innerHTML = '';
    
    if (this.reviews.length === 0) {
      // Show "no reviews" message
      const noReviewsDiv = document.createElement('div');
      noReviewsDiv.className = 'no-reviews';
      noReviewsDiv.innerHTML = '<p>No reviews yet. Be the first to share your thoughts!</p>';
      reviewsList.appendChild(noReviewsDiv);
      loadMoreWrapper.style.display = 'none';
    } else {
      // Calculate pagination
      const startIndex = 0;
      const endIndex = this.currentPage * this.reviewsPerPage;
      const reviewsToShow = this.reviews.slice(startIndex, endIndex);
      
      // Render reviews
      reviewsToShow.forEach(review => {
        const reviewEl = this.createReviewElement(review);
        reviewsList.appendChild(reviewEl);
      });
      
      // Show/hide load more button
      if (this.reviews.length > endIndex) {
        loadMoreWrapper.style.display = 'block';
      } else {
        loadMoreWrapper.style.display = 'none';
      }
    }
    
    // Update average rating
    this.updateAverageRating();
  }

  // Create review element
  createReviewElement(review) {
    const div = document.createElement('div');
    div.className = 'review-item';
    
    const date = new Date(review.date);
    const formattedDate = date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
    
    div.innerHTML = `
      <div class="review-header">
        <div class="reviewer-info">
          <span class="reviewer-name">${this.escapeHtml(review.name)}</span>
          ${review.verified ? '<span class="verified-badge" style="color: #28a745; font-size: 14px;">✓ Verified Purchase</span>' : ''}
        </div>
        <span class="review-date">${formattedDate}</span>
      </div>
      <div class="review-rating">
        ${this.createStarDisplay(review.rating)}
      </div>
      ${review.title ? `<h4 class="review-title">${this.escapeHtml(review.title)}</h4>` : ''}
      <div class="review-body">${this.escapeHtml(review.body)}</div>
    `;
    
    return div;
  }

  // Create star display HTML
  createStarDisplay(rating) {
    let stars = '';
    for (let i = 1; i <= 5; i++) {
      if (i <= rating) {
        stars += '<span class="star">★</span>';
      } else {
        stars += '<span class="star star-empty">★</span>';
      }
    }
    return stars;
  }

  // Update average rating display
  updateAverageRating() {
    if (this.reviews.length === 0) {
      document.getElementById('rating-value').textContent = '0.0';
      document.getElementById('review-count').textContent = '0';
      this.updateStarDisplay(0);
      return;
    }
    
    const totalRating = this.reviews.reduce((sum, review) => sum + review.rating, 0);
    const average = (totalRating / this.reviews.length).toFixed(1);
    
    document.getElementById('rating-value').textContent = average;
    document.getElementById('review-count').textContent = this.reviews.length;
    this.updateStarDisplay(Math.round(average));
  }

  // Update star display in header
  updateStarDisplay(rating) {
    const stars = document.querySelectorAll('#stars-display .star');
    stars.forEach((star, index) => {
      if (index < rating) {
        star.classList.remove('star-empty');
      } else {
        star.classList.add('star-empty');
      }
    });
  }

  // Escape HTML to prevent XSS
  escapeHtml(text) {
    const map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    };
    return text.replace(/[&<>"']/g, function(m) { return map[m]; });
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new ProductReviews();
});